var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_balloon setting_balloon_column_edit" },
    [
      _c("div", { staticClass: "setting_balloon_content" }, [
        _c(
          "div",
          {
            staticClass:
              "setting_balloon_content_main customize_setting_content_main"
          },
          [
            _c("div", { staticClass: "setting_balloon_rows" }, [
              _c("div", { staticClass: "setting_balloon_rows_label" }, [
                _c("p", { staticClass: "setting_balloon_rows_label_name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.screenLabelsProperties.ITEM_NAME_INPUT_TITLE) +
                      "\n          "
                  )
                ]),
                _c("p", { staticClass: "setting_label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.screenLabelsProperties.REQUIRE_LABEL) +
                      "\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "setting_balloon_rows_form" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.itemName,
                      expression: "item.itemName"
                    }
                  ],
                  staticClass: "setting_form_text",
                  attrs: {
                    type: "text",
                    placeholder:
                      _vm.screenLabelsProperties.ITEM_NAME_PLACEHOLDER
                  },
                  domProps: { value: _vm.item.itemName },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "itemName", $event.target.value)
                      },
                      function($event) {
                        return _vm.validateItemName()
                      }
                    ]
                  }
                }),
                _vm.nameError
                  ? _c("p", { staticClass: "error-message" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.screenMaxlengthProperties.MAX_LENGTH_ITEM_NAME +
                              _vm.screenMessagesProperties.OVERLENGTH_ITEM_NAME
                          ) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "setting_balloon_rows" }, [
              _c("div", { staticClass: "setting_balloon_rows_label" }, [
                _c("p", { staticClass: "setting_balloon_rows_label_name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.screenLabelsProperties.ANNOTATION_INPUT_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "setting_balloon_rows_form" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.annotationText,
                      expression: "item.annotationText"
                    }
                  ],
                  staticClass: "setting_form_text",
                  attrs: {
                    type: "text",
                    placeholder:
                      _vm.screenLabelsProperties.ANNOTATION_PLACEHOLDER
                  },
                  domProps: { value: _vm.item.annotationText },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.item,
                          "annotationText",
                          $event.target.value
                        )
                      },
                      function($event) {
                        return _vm.validateItemAnnotation()
                      }
                    ]
                  }
                }),
                _vm.annotationError
                  ? _c("p", { staticClass: "error-message" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.screenMaxlengthProperties
                              .MAX_LENGTH_ANNOTATION +
                              _vm.screenMessagesProperties.OVERLENGTH_ANNOTATION
                          ) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "setting_balloon_rows" }, [
              _c("div", { staticClass: "setting_balloon_rows_label" }, [
                _c("p", { staticClass: "setting_balloon_rows_label_name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.screenLabelsProperties.ITEM_RESOURCE_INPUT_TITLE
                      ) +
                      "\n          "
                  )
                ]),
                _c("p", { staticClass: "setting_label" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.screenLabelsProperties.REQUIRE_LABEL) +
                      "\n          "
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "setting_balloon_rows_form" },
                [
                  _vm._l(_vm.item.resourceField, function(_, index) {
                    return [
                      index === 0 ||
                      _vm.checkItemLength(index) !== 0 ||
                      _vm.isEmptyResources[index]
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass: "setting_balloon_rows_form_box"
                            },
                            [
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    list: _vm.item.resourceField[index],
                                    group: {
                                      name: "item-category",
                                      put: _vm.checkCanAdd(index)
                                    },
                                    draggable: ".item"
                                  },
                                  on: {
                                    add: function($event) {
                                      return _vm.addItemToResourceField(index)
                                    }
                                  }
                                },
                                [
                                  _vm._l(
                                    _vm.item.resourceField[index],
                                    function(subResource, subIndex) {
                                      return _c(
                                        "div",
                                        { key: subIndex, staticClass: "item" },
                                        [
                                          !subResource.itemResourceDeleted
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "setting_form_wrapper_customize",
                                                    class: subResource.display_name
                                                      ? "display_form_grid"
                                                      : ""
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "setting_options_category_item customize_setting_item",
                                                        class: subResource.isResourceDeletedByMainSystem
                                                          ? "resource-delete-setting"
                                                          : "",
                                                        style: [
                                                          !subResource.display_name &&
                                                          _vm.checkItemLength(
                                                            index
                                                          ) !== 1
                                                            ? {
                                                                marginRight:
                                                                  "20px"
                                                              }
                                                            : {}
                                                        ]
                                                      },
                                                      [
                                                        subResource.display_name
                                                          ? _c(
                                                              "svg",
                                                              {
                                                                staticClass:
                                                                  "setting_options_category_item_icon",
                                                                attrs: {
                                                                  width: "10",
                                                                  height: "12",
                                                                  xmlns:
                                                                    "http://www.w3.org/2000/svg"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "g",
                                                                  {
                                                                    attrs: {
                                                                      fill:
                                                                        "#aaa",
                                                                      "fill-rule":
                                                                        "evenodd"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c("input", {
                                                          staticClass:
                                                            "customize_input",
                                                          class: subResource.isResourceDeletedByMainSystem
                                                            ? "resource-delete-setting"
                                                            : "",
                                                          attrs: {
                                                            type: "text",
                                                            disabled: "",
                                                            placeholder:
                                                              _vm
                                                                .screenLabelsProperties
                                                                .DRAG_DROP_PLACEHOLDER
                                                          },
                                                          domProps: {
                                                            value:
                                                              subResource.display_name
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    !(
                                                      subResource.display_name ===
                                                        "" &&
                                                      _vm.checkItemLength(
                                                        index
                                                      ) === 1
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            class: subResource.display_name
                                                              ? "setting_form_wrapper_close"
                                                              : "setting_form_wrapper_delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeResource(
                                                                  subIndex,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            subResource.display_name
                                                              ? _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      width:
                                                                        "12",
                                                                      height:
                                                                        "12",
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "g",
                                                                      {
                                                                        attrs: {
                                                                          fill:
                                                                            "none",
                                                                          "fill-rule":
                                                                            "evenodd"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "rect",
                                                                          {
                                                                            attrs: {
                                                                              fill:
                                                                                "#555",
                                                                              width:
                                                                                "12",
                                                                              height:
                                                                                "12",
                                                                              rx:
                                                                                "2"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "g",
                                                                          {
                                                                            attrs: {
                                                                              fill:
                                                                                "#FFF"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs: {
                                                                                  d:
                                                                                    "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                                                }
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs: {
                                                                                  d:
                                                                                    "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      width:
                                                                        "12",
                                                                      height:
                                                                        "12",
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "g",
                                                                      {
                                                                        attrs: {
                                                                          fill:
                                                                            "#AAA",
                                                                          "fill-rule":
                                                                            "evenodd"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "path",
                                                                          {
                                                                            attrs: {
                                                                              d:
                                                                                "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "path",
                                                                          {
                                                                            attrs: {
                                                                              d:
                                                                                "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  _vm.isEmptyResources[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "setting_form_wrapper_customize",
                                          class: {
                                            "mt-3":
                                              _vm.checkItemLength(index) !== 0
                                          },
                                          attrs: { slot: "footer" },
                                          slot: "footer"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "setting_form_text",
                                            attrs: {
                                              type: "text",
                                              placeholder:
                                                _vm.screenLabelsProperties
                                                  .DRAG_DROP_PLACEHOLDER,
                                              disabled: ""
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "setting_balloon_rows_form_add"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "setting_balloon_rows_form_add_btn",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.addNewBlankResource(index)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.screenLabelsProperties
                                              .ADD_BLANK_ITEM_LINK
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "setting_balloon_rows_form_add_btn",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.addNewEmptySubResource(
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.screenLabelsProperties
                                              .ADD_COLUMN_LINK
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }),
                  _c("div", { staticClass: "setting_balloon_rows_form_add" }, [
                    _c(
                      "a",
                      {
                        staticClass: "setting_balloon_rows_form_add_btn",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addNewLine()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.screenLabelsProperties.ADD_ROW_LINK) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            ])
          ]
        ),
        _c("div", { staticClass: "setting_balloon_content_sub" }, [
          _c("ul", { staticClass: "setting_balloon_content_sub_list" }, [
            _c("li", { staticClass: "setting_balloon_content_sub_item" }, [
              _c(
                "label",
                {
                  staticClass: "setting_balloon_content_sub_label",
                  class: _vm.item.itemRequired ? "is_checked" : ""
                },
                [
                  _c(
                    "div",
                    { staticClass: "setting_balloon_content_sub_label_box" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.itemRequired,
                            expression: "item.itemRequired"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "item_required",
                          disabled: _vm.hasItemRequired,
                          value: "true"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.item.itemRequired)
                            ? _vm._i(_vm.item.itemRequired, "true") > -1
                            : _vm.item.itemRequired
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.item.itemRequired,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "true",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.item,
                                    "itemRequired",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.item,
                                    "itemRequired",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.item, "itemRequired", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "setting_balloon_content_sub_label_name"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.screenLabelsProperties.REQUIRE_ITEM_LABEL
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "p",
                    { staticClass: "setting_balloon_content_sub_label_text" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.screenLabelsProperties.REQUIRE_ITEM_MESSAGE
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            ]),
            _c("li", { staticClass: "setting_balloon_content_sub_item" }, [
              _c(
                "label",
                {
                  staticClass: "setting_balloon_content_sub_label",
                  class: _vm.item.viewAnnotation ? "is_checked" : ""
                },
                [
                  _c(
                    "div",
                    { staticClass: "setting_balloon_content_sub_label_box" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.viewAnnotation,
                            expression: "item.viewAnnotation"
                          }
                        ],
                        attrs: { type: "checkbox", value: "true" },
                        domProps: {
                          checked: Array.isArray(_vm.item.viewAnnotation)
                            ? _vm._i(_vm.item.viewAnnotation, "true") > -1
                            : _vm.item.viewAnnotation
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.item.viewAnnotation,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "true",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.item,
                                    "viewAnnotation",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.item,
                                    "viewAnnotation",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.item, "viewAnnotation", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "setting_balloon_content_sub_label_name"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.screenLabelsProperties.ANNOTATION_OPTION
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "p",
                    { staticClass: "setting_balloon_content_sub_label_text" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.screenLabelsProperties.ANNOTATION_MESSAGE
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            ]),
            _c("li", { staticClass: "setting_balloon_content_sub_item" }, [
              _c("div", { staticClass: "setting_balloon_content_sub_label" }, [
                _c(
                  "span",
                  {
                    staticClass: "setting_balloon_content_sub_label_name bold"
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.screenLabelsProperties.ABOUT_INPUT_TITLE) +
                        "\n            "
                    )
                  ]
                ),
                _c(
                  "p",
                  { staticClass: "setting_balloon_content_sub_label_text" },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.screenLabelsProperties.ABOUT_MESSAGE) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "setting_balloon_footer" }, [
        _c(
          "button",
          {
            staticClass: "setting_btn_outline setting_btn_small",
            on: {
              click: function($event) {
                return _vm.onClose()
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.screenLabelsProperties.CLOSE_MODAL) +
                "\n    "
            )
          ]
        ),
        _c(
          "button",
          {
            staticClass: "setting_btn_primary setting_btn_small",
            class: { setting_btn_disabled: _vm.isDisableSubmitButton() },
            on: {
              click: function($event) {
                return _vm.onSubmit()
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.screenLabelsProperties.SAVE_ITEM) +
                "\n    "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }